import React, { useEffect } from "react";
import { Box } from "@mui/material";
import HeroSection from "./sections/HeroSection";
import BenefitsSection from "./sections/BenefitsSection";
import DifferentiatorsSection from "./sections/DifferentiatorsSection";
import TemplatesSection from "./sections/TemplatesSection";
import AddOnsSection from "./sections/AddOnsSection";
import PowerfulFeaturesSection from "./sections/PowerfulFeaturesSection";

const SmartReportingNewPage = () => {
  // ── Clarity Event Tracking ──────────────────────────────────────────────
  useEffect(() => {
    // Shared list of templates and add-ons to check against
    const items = [
      // Templates
      { keyword: 'personal', tag: 'template_personal', event: 'sr_sub_template_personal_preview_clicked' },
      { keyword: 'total', tag: 'template_total', event: 'sr_sub_template_total_preview_clicked' },
      { keyword: 'compact', tag: 'template_compact', event: 'sr_sub_template_compact_preview_clicked' },
      // Add-Ons
      { keyword: 'body summary', tag: 'addon_body_summary', event: 'sr_sub_addon_body_summary_preview_clicked' },
      { keyword: 'cover page', tag: 'addon_cover_page', event: 'sr_sub_addon_cover_page_preview_clicked' },
      { keyword: 'recommender', tag: 'addon_text_recommender', event: 'sr_sub_addon_text_recommender_preview_clicked' }
    ];

    const handleClick = (e) => {
      if (typeof window.clarity !== 'function') return;

      // Allow bubbling up to find the button or clickable div
      const el = e.target.closest('button, [role="button"], [class*="Mui"], [class*="css-"], div') || e.target;
      if (!el) return;

      const text = el.innerText?.trim().toLowerCase() || '';

      // We only care about buttons that say "preview"
      if (text.includes('preview')) {
        // Find the parent card to inspect its heading/title
        const card = el.closest('div[class*="MuiBox"], div[class*="css-"], div');
        const heading = card?.querySelector('h2, h3, h4, p, [class*="Typography"]')?.innerText?.trim().toLowerCase() || '';

        // Match against our items array
        items.forEach(({ keyword, tag, event }) => {
          if (heading.includes(keyword)) {
            window.clarity('set', 'sr_sub_preview_clicked', tag);
            window.clarity('event', event);
          }
        });
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
  // ────────────────────────────────────────────────────────────────────────

  // Use SVG from public folder (same pattern as SmartReporting page)
  const backgroundSvgPath = "/images/smartReportingNew/job297-ploy-07c-blue-01.svg";

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "transparent",
        backgroundImage: `url(${backgroundSvgPath})`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "scroll",
      }}
    >
      {/* Content wrapper to ensure all sections appear above background */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
        }}
      >
        {/* Hero Section */}
        <HeroSection />

        {/* Benefits Section */}
        <BenefitsSection />

        {/* Differentiators Section */}
        <DifferentiatorsSection />

        {/* Templates Section */}
        <TemplatesSection />

        {/* Add-Ons Section */}
        <AddOnsSection />

        {/* Powerful Features Section */}
        <PowerfulFeaturesSection />
      </Box>
    </Box>
  );
};

export default SmartReportingNewPage;